import { render, staticRenderFns } from "./InserirAtualizarAnexoForm.vue?vue&type=template&id=4d1549f1"
import script from "./InserirAtualizarAnexoForm.vue?vue&type=script&lang=js"
export * from "./InserirAtualizarAnexoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports